module.exports = __webpack_public_path__ + "static/img/pangxie.82503a3b.png";